@let canManageInterviewTemplatesValue = canManageInterviewTemplates();
@let allGroupedEvaluationFormsValue = allGroupedEvaluationForms();
@let contextValue = context();

<rt-dropdown [width]="DropdownWidth.LargeXX" (click)="$event.preventDefault()">
  <rt-evaluation-dropdown-header
    [heading]="'app.interview.request_evaluation' | translate"
    [canManageInterviewTemplates]="canManageInterviewTemplatesValue"
  />

  @if (allGroupedEvaluationFormsValue.length) {
    <rt-request-evaluation-dropdown-form
      [form]="form"
      [offers]="offers()"
      [groupedTemplates]="visibleTemplates()"
      [templatesLoaded]="templatesLoaded()"
      [context]="contextValue"
      [canViewCandidates]="canViewCandidates()"
      [timeData]="timeData()"
      [dueDateConfig]="dueDateConfig()"
      [sendAtKind]="sendAtKind()"
      [isSchedulerLink]="isSchedulerLink()"
      (timeDataChange)="timeData.set($event)"
      (dueDateConfigChange)="dueDateConfig.set($event)"
      (sendAtKindChange)="sendAtKind.set($event)"
      (editAssignments)="onEditAssignments()"
    />
    @if (shouldShowScaleBanner) {
      <div padding-lr>
        <rt-feature-discovery-banner
          [title]="'app.interview.scale_banner.title' | translate"
          [description]="'app.interview.scale_banner.description' | translate"
          [ctaText]="'app.interview.scale_banner.cta' | translate"
          [variant]="'default'"
          [dismissible]="false"
          [textTemplate]="scaleBannerText"
          (ctaClick)="openEvaluationScaleSettings()"
          margin-bottom
        />
        <ng-template #scaleBannerText let-description="description" let-title="title">
          <rt-heading variant="heading">{{ title }}</rt-heading>
          <rt-heading variant="subheading dark normal">{{ description }}</rt-heading>
        </ng-template>
      </div>
    }
    <rt-divider />
    <rt-request-evaluation-dropdown-footer
      [context]="contextValue"
      [isFormValid]="isFormValid()"
      (close)="onClose()"
      (submit)="onSubmit()"
    />
  } @else {
    <rt-evaluation-dropdown-empty-state />
  }
</rt-dropdown>
